import ServiceResponse from './models/ServiceResponse';
import { format } from '../utils/string';

import {
  deleteUserCreditCardURL,
  agreementStatusTermsAndConditionsURL,
  agreeTermsAndConditionsURL,
  userFavoritesURL,
} from './urls/apiGatewayURLs';

const ENTITY_TYPE = 'PARTNER';
const ERROR_RESTAURANT_REQUIRED = 'restaurantId param is required';

export async function deleteFavorites({ axios, restaurantId }) {
  try {
    if (!restaurantId)
      return new ServiceResponse({ error: ERROR_RESTAURANT_REQUIRED });

    const { data } = await axios.delete(`${userFavoritesURL}/${restaurantId}`, {
      params: { entityType: ENTITY_TYPE },
    });

    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export async function addFavorites({ axios, restaurantId }) {
  try {
    if (!restaurantId)
      return new ServiceResponse({ error: ERROR_RESTAURANT_REQUIRED });

    const { data } = await axios.post(userFavoritesURL, {
      entityType: ENTITY_TYPE,
      entityId: restaurantId,
    });

    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export function fetchUserCreditCards() {
  return new ServiceResponse({ data: { data: [] } });
}

export async function deleteUserPaymentMethod({ axios, paymentMethodId }) {
  try {
    const url = format(deleteUserCreditCardURL, paymentMethodId);
    await axios.delete(url);
    return new ServiceResponse({ success: true });
  } catch (error) {
    return new ServiceResponse({
      error,
    });
  }
}

export async function getStatusTermsAndConditions({ axios, countryId }) {
  try {
    const response = await axios.get(
      format(agreementStatusTermsAndConditionsURL, countryId),
    );

    return new ServiceResponse({ data: response.data });
  } catch (error) {
    return new ServiceResponse({
      error,
    });
  }
}

export async function agreeTermsAndConditions({ axios, countryId }) {
  try {
    await axios.post(format(agreeTermsAndConditionsURL, countryId), {});

    return new ServiceResponse({ success: true });
  } catch (error) {
    return new ServiceResponse({
      error,
    });
  }
}
